//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import { mapActions, mapGetters } from "vuex";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
    name: "ContractDetails",

    components: {
        AQInput,
        AQDropdown
    },
    props: {
        data: { type: Object, default: () => {} },
        currentContract: { type: Object, default: () => {} },
        disabledParam: { type: Boolean, default: false },
        scEditMode: { type: String, default: "create" }
    },
    data() {
        return {
            readOnly: false,
            disabledValue: false,
            readOnlyType: false,
            disabledOnImport: false,
            change: false,
            resetCredentials: false,
            resetNetwork: false,
            disabledField: false,
            scObject: {
                id: null,
                name: "",
                description: "",
                type: [],
                network: "",
                credentials: null,
                address: this.$t("smartContract.scAddressInfo")
            },
            scObjectCopy: {},
            defaultNetwork: "",
            defaultType: "",
            defaultCredentials: "",
            contract: {},
            currentContractId: "",
            bcTypeId: "",
            updated: false
        };
    },
    computed: {
        ...mapGetters("smartContractDesigner", ["getterScTypes", "getterScCredentials", "getterScNetworks"]),
        contractAddress() {
            return this.$t("smartContract.scAddressInfo");
        },

        scTypeOptions() {
            return this.getterScTypes.map(type => ({
                label: type.label,
                value: type.id
            }));
        },
        computedSCName: {
            get() {
                return this.scObject.name;
            },
            set(newName) {
                this.scObject.name = newName.charAt(0).toUpperCase() + newName.slice(1);
            }
        }

    },

    watch: {
        disabledParam: {
            handler(value) {
                if (value !== this.disabledField) {
                    this.disabledField = value;
                }
            },
            immediate: true
        }
    },

    validations: {
        scObject: {
            name: { required },
            type: {
                required: requiredIf(function () {
                    return this.scEditMode !== "import";
                })
            },
            network: { required },
            credentials: {
                required: requiredIf(function () {
                    return !this.currentContract.imported && this.scEditMode !== "import";
                })
            },
            address: {
                required: requiredIf(function () {
                    return this.scEditMode === "import";
                })
            }
        }
    },
    created() {
        if (!this.getterScTypes || !this.getterScTypes.length) {
            this.getScTypes();
        }
    },

    mounted() {
        this.checkPublishStatus();
        if (this.currentContract && Object.keys(this.currentContract).length) {
            Object.assign(this.contract, this.currentContract);
            this.loadData(this.contract);
        } else {
            this.contractId = window.localStorage.getItem("currentContractId");
            this.bcTypeId = window.localStorage.getItem("bcTypeId");
            if (this.contractId && this.bcTypeId) {
                this.networkAndCredentials(this.bcTypeId);
                this.getContract(this.contractId).then(contract => {
                    this.contract = { ...contract };
                    this.loadData(this.contract);
                });
            }
        }
    },
    updated() {
        this.updated = true;
    },
    methods: {
        ...mapActions("smartContractDesigner", ["getScTypes", "getScCredentials", "getScNetworks", "saveSmartContract", "getContract"]),
        returnType(value) {
            let typeToReturn = "";
            if (this.$route.name === "useTemplate") {
                if (value && value.length) {
                    typeToReturn = value.find(element => element.label === "Etherum");
                    this.disabledValue = true;
                    this.change = false;
                    this.networkAndCredentials(typeToReturn.value);
                    return typeToReturn.value;
                }
            } else {
                this.defaultType = (this.contract && this.contract.bcType && this.contract.bcType.id) ? this.contract.bcType.id : null;
                return this.defaultType;
            }
            return typeToReturn;
        },
        networkAndCredentials(value) {
            if ((this.getterScNetworks && !this.getterScNetworks.length) || this.change) {
                this.getScNetworks(value).then(() => {
                    this.scNetworkOptions();
                });
            }
            if ((this.getterScCredentials && !this.getterScCredentials.length) || this.change) {
                this.getScCredentials(value).then(() => {
                    this.scCredentialsOptions();
                });
            }
        },
        scCredentialsOptions() {
            let credentials = [];
            if (this.getterScCredentials && this.getterScCredentials.length) {
                credentials = this.getterScCredentials.map(credential => ({
                    label: credential.name,
                    value: credential.id
                }));
            }
            return credentials;
        },
        scNetworkOptions() {
            let network = [];
            if (this.getterScNetworks && this.getterScNetworks.length) {
                network = this.getterScNetworks.map(scNetwork => ({
                    label: scNetwork.name,
                    value: scNetwork.id
                }));
            }
            return network;
        },
        selectedNetworkValue(val) {
            if (val && val.length) {
                this.resetNetwork = false;
            }
        },

        selectedCredentialsValue(val) {
            if (val && val.length) {
                this.resetCredentials = false;
            }
        },
        checkFieldsValue() {
            const regex = /^[A-Za-z0-9_]+$/;
            const checkSpecialCharacther = regex.test(this.scObject.name);
            return this.scObject.name && this.scObject.network.length && checkSpecialCharacther
                && this.scObject.credentials.length && this.scObject.type.length;
        },

        checkRequired() {
            if (this.updated) {
                const dirty = this.isDirty();
                const canSave = this.checkFieldsValue() && dirty;
                const toSend = dirty ? this.scObject : {};
                this.$emit("dataFromScartch", { object: toSend, variable: !canSave });
            }
        },
        showValue(value) {
            this.change = true;
            this.disabledField = false;
            this.resetCredentials = true;
            this.resetNetwork = true;
            if (value && value.length) {
                this.networkAndCredentials(value[0].value);
            } else {
                this.disabledField = true;
            }
        },

        isDirty() {
            return JSON.stringify(this.scObject) !== JSON.stringify(this.scObjectCopy);
        },

        loadData(contract) {
            if (contract && contract.id) {
                this.scObject.id = contract.id;
                this.scObject.name = contract.name;
                this.scObject.description = contract.description;
                const typeSelected = this.getterScTypes.filter(el => el.id === contract.bcType.id);
                if (typeSelected) {
                    this.scObject.type = typeSelected.map(type => ({
                        label: type.label,
                        value: type.id
                    }));
                }
                this.defaultType = (contract.bcType && contract.bcType.id) ? contract.bcType.id : "";
                const networkSelected = contract.network && contract.network.id ? this.getterScNetworks.filter(el => el.id === contract.network.id) : "";
                if (networkSelected) {
                    this.scObject.network = networkSelected.map(network => ({
                        label: network.name,
                        value: network.id
                    }));
                }
                this.defaultNetwork = (contract.network && contract.network.id) ? contract.network.id : "";
                const credentialsSelected = contract.credentials && contract.credentials.id ? this.getterScCredentials
                    .filter(el => el.id === contract.credentials.id) : "";
                if (credentialsSelected) {
                    this.scObject.credentials = credentialsSelected.map(credentials => ({
                        label: credentials.name,
                        value: credentials.id
                    }));
                }
                this.defaultCredentials = (contract.credentials && contract.credentials.id) ? contract.credentials.id : null;
                if (contract.address) {
                    this.scObject.address = contract.address;
                }
                this.scObjectCopy = JSON.parse(JSON.stringify(this.scObject));
                this.$oneAtATime.createRoom("smartContractList", contract.id);
                this.$root.$on("oneAtATime-smartContractList", () => {
                    this.readOnly = !this.$oneAtATime.state.$currentRoomEmpty;
                    this.readOnlyType = !this.$oneAtATime.state.$currentRoomEmpty;
                    this.disabledOnImport = false;
                });
                this.disabledOnImport = (this.scEditMode === "import") || (this.contract.publishStatus === "IMPORTED");
            } else if (this.data) {
                const {
                    name, description, network, credentials
                } = this.data;
                this.scObject.name = name;
                this.scObject.description = description;
                this.scObject.network = (network && network.length) ? network[0].value : "";
                this.scObject.credentials = (credentials && credentials.length) ? credentials[0].value : "";
                this.defaultNetwork = this.scObject.network;
                this.defaultCredentials = this.scObject.credentials;
                this.disabledOnImport = (this.scEditMode === "import") || (this.contract.publishStatus === "IMPORTED");
            } else {
                this.scObjectCopy = JSON.parse(JSON.stringify(this.scObject));
            }
            this.checkPublishStatus();
        },

        checkPublishStatus() {
            const contractToCheck = Object.keys(this.currentContract).length !== 0 ? this.currentContract : this.contract;
            const { publishStatus } = contractToCheck;
            if (publishStatus === "PUBLISHED" || publishStatus === "UNPUBLISHED_CHANGES"
                || publishStatus === "IMPORTED") {
                this.readOnlyType = true;
            }
        }
    }

};

